import { render } from "./OverlayMenu.vue?vue&type=template&id=01acc964"
import script from "./OverlayMenu.vue?vue&type=script&lang=js"
export * from "./OverlayMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__